// extracted by mini-css-extract-plugin
module.exports = {"container":"PageTemplate_container__13Hwu","content":"PageTemplate_content__2QgN9"};